/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, bool, string,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import allStates from './StateList.json';
import ErrorMessage from './ErrorMessage';

const useStyles = makeStyles((theme) => ({
    stateWrapper: {
        display: 'flex',
        height: 27,
        maxWidth: '50%',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        },
    },
    selectWrapper: {
        flex: 2,
    },
    customSelect: {
        border: 'none',
        width: '100%',
        background: '#f3f3f3',
        appearance: 'none',
        height: 27,
        fontSize: '1rem',
        padding: '3px 0 0 10px !important',
        '&:before': {
            border: 'none',
        },
        '&:hover': {
            '&:before': {
                border: 'none!important',
            },
        },
        '& .MuiSelect-select': {
            '&.MuiSelect-select:focus': {
                backgroundColor: 'transparent!important',
            },
        },
    },
    customLabel: {
        flex: 1,
        color: theme.palette.black,
        fontSize: '.8125rem',
        [theme.breakpoints.down('md')]: {
            fontSize: '1rem',
        },
    },
    errorMessage: {
        margin: 0,
        textAlign: 'center',
        lineHeight: 1,
    },
}));

export default function ProductStateSection({
    handleStateChange, selectedState, alertType, addToCartClicked,
}) {
    const classes = useStyles();
    const stateError = addToCartClicked && (!selectedState ||  alertType);
    return (
        <div className={classes.stateWrapper}>
            <InputLabel id="state-dropdown" htmlFor="state-dropdown" className={classes.customLabel}><span>Delivery State<sup>*</sup></span></InputLabel>
            <FormControl className={classes.selectWrapper} error={stateError}>
                <Select
                    value={selectedState}
                    id="state-dropdown"
                    onChange={(e) => handleStateChange(e)}
                    className={classes.customSelect}
                    aria-labelledby="state-dropdown"
                    SelectDisplayProps={{
                        'aria-label': 'Delivery State',
                    }}
                >
                    {allStates.map((state) => (
                        <MenuItem value={state.code} key={state.name}>{state.name}</MenuItem>
                    ))}
                </Select>
                {(stateError) && <FormHelperText className={classes.errorMessage}>{ErrorMessage[alertType] || ErrorMessage['stateValidtion']}</FormHelperText>}
            </FormControl>
        </div>
    );
}

ProductStateSection.propTypes = {
    handleStateChange: func.isRequired,
    selectedState: string.isRequired,
    alertType: string.isRequired,
    addToCartClicked: bool.isRequired,
};
